// Substrate carries state and integrates through the field. Alpha is shaped by
// age so particles fade in and out rather than popping on respawn.
import { push } from '../drawlist.js'
import { inPlane } from './shift.js'

export default {
  id: 'advect',
  label: 'Advect',
  stateful: true,

  // No wantGradient here: advection steers by the gradient, so flow alignment
  // is already paid for and comes free.
  fill(list, substrate, field, cfg, motion, t) {
    const s = substrate.state
    const rnd = substrate.rnd
    const spin = t * motion.spin
    const fromValue = motion.align === 'field'
    const fixed = motion.align === 'fixed'
    for (let i = 0; i < substrate.count; i++) {
      const o = i * 5
      const x = s[o], y = s[o + 1]
      const angle = field.gradient(x, y, t)
      const v = field.sample(x, y, t)

      s[o] += Math.cos(angle) * cfg.step
      s[o + 1] += Math.sin(angle) * cfg.step
      s[o + 3] += 1

      if (s[o + 3] > s[o + 4] || s[o] < -1.3 || s[o] > 1.3 || s[o + 1] < -1.3 || s[o + 1] > 1.3) {
        s[o] = rnd() * 2 - 1
        s[o + 1] = rnd() * 2 - 1
        s[o + 2] = 0
        s[o + 3] = 0
        s[o + 4] = cfg.lifespan * (0.5 + rnd())
      }

      const base = fixed ? 0 : fromValue ? v : angle
      const fade = 1 - Math.abs(s[o + 3] / s[o + 4] - 0.5) * 2
      // Displaces what is drawn, not what is simulated: the particle's own
      // position stays in the substrate state, so the flow is unaffected.
      const d = motion.shift ? inPlane(motion.axis, x, y, v * motion.shift, angle) : null
      push(list, d ? d.x : x, d ? d.y : y, s[o + 2] + v * motion.displace, v,
        base * motion.twist + spin, 0.35 + fade * 0.65)
    }
  },
}
